module.exports = {
	"about": "के बारे में",
	"accepted_invitation_from": "आपने {invitedBy} का आमंत्रण स्वीकार किया है और शामिल होने के लिए {coins} बोनस कमाया है| ",
	"accepted_invitation_from_friend": "आपके मित्र {displayName} ने आपका निमंत्रण स्वीकार कर लिया है| आपने {coins} बोनस के रूप मे कमाया है!|",
	"account_disabled": "आपका खाता विकलांग किया गया है। कृपया hello@cricrush.com पर संपर्क करें|",
	"all_entries": "सभी प्रविष्टियों",
	"already_registered": "पहले से पंजीकृत? ",
	"can_t_find_account": "ओह, हम आपका खाता नहीं ढूंढ सके| कृपया एक बनाएं|",
	"cant_placed_entries": "आपने कोई प्रविष्टि नहीं रखी है|",
	"change_profile_picture": "प्रोफ़ाइल चित्र बदलें",
	"chat_modal_name": "बातचीत",
	"claim": "दावा",
	"click_here_to_resend": "जाँच पुनः भेजें",
	"close": "बंद करे",
	"coming_soon": "जल्द आ रहा है",
	"confirm": "पक्का करें",
	"countdown_day": "दिन",
	"countdown_days": "दिन",
	"countdown_hours": "घंटे",
	"countdown_minutes": "मिनट",
	"countdown_seconds": "सेकंड",
	"create_account": "खाता बनाएं",
	"cricrush_league": "Cricrush संघ",
	"do_not_have_an_account": "क्या आपका कोई खाता नहीं है?",
	"dream_team": "सपने की टीम",
	"dream_team_entry": "ड्रीम टीम एंट्री",
	"dream_team_entry_creation_modal_name": "ड्रीम टीम प्रविष्टि रचना",
	"dream_team_leagues": "ड्रीम टीम लीग",
	"earn_coins_bonuses": " बोनस के सिक्के कमाएं",
	"edition": "संस्करण",
	"email_not_verified": "ईमेल सत्यापित नहीं है",
	"email_not_verified_to_claim_rewards": "पुरस्कार का दावा करने के लिए कृपया अपना ईमेल सत्यापित करें",
	"email_title": "ईमेल",
	"enter_valid_email": "मान्य ईमेल दर्ज करें",
	"entries": "प्रविष्टियां",
	"entry_created": " - प्रवेश बनाया गया",
	"favourite_teams": "पसंदीदा टीम",
	"fb_reauth": "facebook से स्थायी करें",
	"fb_signin": "facebook से लोगिन करें ",
	"fb_signup": "facebook के साथ साइन अप करें",
	"fire_base_already_login_different provider": "आपने अलग प्रदाता का उपयोग करके पहले साइन अप किया है| कृपया सही प्रदाता का उपयोग करके प्रवेश करें।",
	"fire_base_wrong_message": "कुछ गलत हो गया है। कृपया बाद में दोबारा प्रयास करें!",
	"friend_invite_accepted": "आपके मित्र {friendName} ने आपका निमंत्रण स्वीकार कर लिया है",
	"ggl_reauth": "google से स्थायी करें",
	"ggl_signin": "google से लोगिन करें",
	"ggl_signup": "google के साथ साइन अप करें ",
	"go_back": "वापस जाएँ",
	"help": "मदद",
	"invalid_mail": "अमान्य ईमेल पता",
	"invitation_accepted": "आमंत्रण स्वीकृत!",
	"invitation_bonus": "आमंत्रण बोनस",
	"invite_friends": "मित्रों को आमंत्रित करें",
	"leaderboard": "लीडरबोर्ड",
	"live": "Live",
	"live_prediction": "लाइव प्रेडिक्शन लीग",
	"live_prediction_entry": "लाइव प्रेडिक्शन प्रविष्टि",
	"login": "लॉगिन करें",
	"login_here": "यहां लॉगिन करें",
	"login_register": "लॉगिन  / पंजीकरण",
	"logout": "लॉगआउट",
	"lost": " - खो गया",
	"lost_title": "खो गया",
	"no_email_with_account": "इस ईमेल से कोई खाता नहीं है| कृपया साइन उप करें",
	"no_network": "नेटवर्क नहीं! है!",
	"no_network_connection": "नेटवर्क कनेक्शन नहीं है!",
	"notifications": "सूचनाएं",
	"or": "या",
	"password_incorrect": "आपके द्वारा दर्ज किया गया पासवर्ड गलत है.",
	"pick_your_country": "अपना देश चुनें",
	"play_button": "प्ले",
	"predict_score": "मैच के लक्ष्य स्कोर की भविष्यवाणी करें",
	"profile": "प्रोफाइल",
	"providers_str": "आपने  पहले {providersStr} का उपयोग किया था| कृपया उन तरीकों में से किसी एक का उपयोग करके फिर से लॉगिन करें",
	"providers_str_try_google": "आपने पहले {providersStr} का उपयोग करके साइन अप किया है| Google का प्रयोग करके लॉगिन करने का प्रयास करें",
	"reauth_modal_title": "क्रिया पूर्ण करने केलिए पुन: प्रमाणीकृत करें",
	"received_invitation_bonus": "आमंत्रण बोनस प्राप्त हुआ",
	"refunded": " - वापस कर दिया",
	"refunded_title": "वापस कर दिया",
	"register_here": "यहां रजिस्टर करें",
	"save": "बचाना",
	"select_country": "देश चुनें और अनुकूलित जीत का आनंद लें!",
	"select_language": "भाषा चुनिए",
	"select_teams": "पसंदीदा टीम",
	"settings": "सेटिंग्स",
	"submit": "जमा करें",
	"target_prediction": "टारगेट प्रेडिक्शन",
	"target_prediction_entry": "टारगेट प्रेडिक्शन प्रविष्टि",
	"total": "कुल",
	"transactions": "लेन-देन",
	"unknown_error": "अज्ञात त्रुटि हुई",
	"upcoming": "आगामी",
	"user_name": "उपयोगकर्ता नाम",
	"valid_number": "कृपया एक सही संख्या डालिये!",
	"weak_password": "कमजोर पासवर्ड, पासवर्ड 6 वर्ण या अधिक लंबा  होना चाहिए.",
	"won": " - जीत लिया",
	"won_lost_refunded_coins": "हे, आपने {earnedCoins} सिक्के जीते,  {lostCoins} सिक्के खोये और  {refundedCoins} सिक्के वापस मिले",
	"won_title": "जीत लिया",
	"you_lost_message": "आप हार गए",
	"you_won": "आप जीते",
	"you_won_reward": "आपने पुरस्कार जीता",
	"your_entries": "आपके प्रविष्टियां",
	"your_live_prediction_entry": "आपका लाइव भविष्यवाणी प्रविष्टि  : {prediction}",
	"your_mom_entry": "आपका मैन ऑफ़ द मैच एंट्री :{momEntry}",
	"your_prediction": "आपका पूर्वानुमान : {prediction}",
	"display_name": "डिस्प्ले नाम",
	"email": "ईमेल",
	"password": "पारण शब्द",
	"runs_cannot_be_negative_value": "रन एक नकारात्मक मूल्य नहीं हो सकता है",
	"budget": "बजट $",
	"view_button": " व्यू",
	"score": "स्कोर: ",
	"rank": "रैंक: ",
	"target_prediction_leagues": "टारगेट प्रेडिक्शन लीग",
	"live_prediction_leagues": "लाइव प्रेडिक्शन लीग",
	"target_prediction_description": "मैच के लक्ष्य स्कोर की भविष्यवाणी करें और अपनी प्रविष्टि दर्ज करें। आपकी प्रविष्टियों को वास्तविक स्कोर के साथ निकटता के आधार पर रैंक किया जाएगा।",
	"required": "Required!",
	"entries_left": " entries left",
	"end_of_results": "End of results",
	"invalid_email_address": "Invalid Email Address",
	"completed": "Completed",
	"dream_team_description": "Pick your 4-player team and create your entry. Now sit back and enjoy the game while your team scores for you.",
	"reward_claimed_title": "Reward Claimed - {reference}",
	"reward_claimed_msg": "Redeemed coins by claiming reward with reference - {reference}",
	"update": "Update",
	"processed": "Processed",
	"claim_reward_instructions_title": "Please read instructions carefully!",
	"invalid_filed_instruction": "{field} is invalid. Please check!",
	"reward_processed": "Reward Processed!",
	"reward_reference": "Your Reference : {reference}",
	"claim_coins_message": "By claiming this reward, you will be reduced {claimCoins} coins.",
	"weekly": "Weekly",
	"daily": "Daily",
	"monthly": "Monthly",
	"lifetime": "Lifetime",
	"local": "Local",
	"global": "Global",
	"no_lb_status_generated": "We don't have enough data to generate this leader board!",
	"you": "You",
	"leaderBoard": "Leader Board",
	"mail_sent": "Email Sent!",
	"verification_mail_sent": "A verification email sent to {email}",
	"messages": "Messages",
	"country_change_warning": "You might loose current leader board ranks if you change your country.",
	"faq": "FAQ",
	"how_scores_calculated": "Score Calculations",
	"how_to_play": "How To Play",
	"live_prediction_description": "Predict the score at the end of {endOver}th over of {teamName}'s batting innings. Your entries will be ranked based on their proximity to real score.",
	"predict_what_message": "Predict the score at the end of {endOver}th over of {teamName}'s batting innings",
	"pick_team": "Pick your 4-player team and win",
	"your_entry_created": "Your entry created !",
	"fica_title": "Officially endorsed by",
	"fica_detailed_text": "Cricrush is the only fantasy cricket app endorsed by FICA",
	"version": "Version",
	"match_help": "Click here to select a match",
	"dream_team_leagues_help": "Click here to select your 4 player team for {matchName}",
	"quick_prediction_leagues_help": "Click here to predict the score at the end of {over}th over",
	"target_prediction_leagues_help": "Click here to predict the target score of {matchName} match",
	"entries_help": "Click here to view your entry scores and ranks updated in real time with live match",
	"more_leaderboard_help": "Click here to check your leaderboard",
	"more_edition_language_help": "Click here and select edition to change your language",
	"more_edition_country_help": "Click here and select edition to change your country",
	"add_coins_help": "Running out of coins? Earn more free coins here",
	"claimed": "Claimed",
	"invite_friends_title": "Invite your friends and get 100 coins when they place their first entry!",
	"daily_claim_bonus_counter_message": "You have already claimed your bonus!",
	"daily_claim_bonus_message": "Claim your free coins now!",
	"daily_login_bonus": "Daily login bonus",
	"daily_login_bonus_claimed": "Daily login bonus claimed",
	"invite_friends_share_title": "Your friend {name} has invited you to join Cricrush",
	"invite_friends_share_message": "Your friend {name} has invited you to join Cricrush. Click the link below to join, play and win exciting gifts",
	"invite_friends_dialog_title": "Invite friends to join",
	"live_status": "LIVE",
	"view_entries": "View {noOfEntries} entries >>",
	"end_of_results2": "That's all we have!",
	"leagues_not_created": "Leagues will be created soon...",
	"add_coins": "Add Coins",
	"expired": "Expired",
	"reward_expired": "Reward Expired!",
	"entries_left2": "{noOfEntries} entries left"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/hi.json
// module id = 487
// module chunks = 0